export class ParentHelper {
    static navigate(url: string = "/dashboard"){
      window.parent.postMessage({
        func : 'onNavigation',
        url : url
      }, "*")
    };
    static loadingPage(status: boolean = true){
      window.parent.postMessage({
        func : 'loadingPage',
        status : status
      }, "*")
    };
   
  }
  